import { useState } from 'react';

const fmt = (n) => '$' + n.toLocaleString('es-CO');

// Precio real = precio lanzamiento / 0.60 (descuento 40%)
const real = (n) => Math.round(n / 0.6 / 1000) * 1000;

const COMPETITORS_TOTAL = 450000;

const CheckIcon = () => (
  <svg className="w-4 h-4 flex-shrink-0 text-brand-400" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const CheckIconWhite = () => (
  <svg className="w-4 h-4 flex-shrink-0 text-white" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

/* ─── Datos de nichos ─── */
const NICHES = [
  {
    id: 'taller',
    label: 'Taller Mecánico',
    icon: '🔧',
    plans: [
      {
        name: 'Básico',
        price: 120000,
        wompiLink: 'https://checkout.wompi.co/l/Tv1cs5',
        users: '2 usuarios + Admin',
        highlight: false,
        badge: null,
        features: [
          'Inventario asesorado por IA',
          'Finanzas + Reportes financieros',
          'Agendador de citas',
          'Historial completo del cliente',
          'Módulo de servicios',
          'Control de clientes',
        ],
        note: null,
        noDiscount: true,
      },
      {
        name: 'Pro',
        price: 150000,
        wompiLink: 'https://checkout.wompi.co/l/PxeJ8c',
        users: '5 usuarios + Admin',
        highlight: true,
        badge: '⚡ LANZAMIENTO 40% OFF',
        features: [
          'Todo lo del Plan Básico',
          'Cuentas de Cobro y Facturación',
          'Cotizador y Facturación Rápida',
          'Chat IA: soporte en inventario y servicios',
          'Gestión de rendimiento e informes',
          'Cálculo de comisión y sueldo',
        ],
        note: null,
      },
      {
        name: 'Premium',
        price: 350000,
        wompiLink: 'https://checkout.wompi.co/l/Hi2dlW',
        users: 'Usuarios ilimitados',
        highlight: false,
        badge: '🏢 MULTI-SEDE',
        features: [
          'Todo lo del Plan Pro',
          'Sin límite de usuarios',
          'Sede principal + 2 sedes incluidas',
          'Sedes adicionales $180.000/sede',
          'Gestión IA completa: finanzas + inventario',
          'Informes avanzados multi-sede',
          'Soporte prioritario dedicado',
        ],
        note: 'Sedes adicionales a $180.000/mes c/u',
        noDiscount: true,
      },
    ],
  },
  {
    id: 'barberia',
    label: 'Barbería · Spa · Belleza',
    icon: '✂️',
    plans: [
      {
        name: 'Básico',
        price: 90000,
        wompiLink: 'https://checkout.wompi.co/l/PDJY87',
        users: '2 usuarios + Admin',
        highlight: false,
        badge: null,
        features: [
          'Inventario asesorado por IA',
          'Finanzas + Reportes financieros',
          'Agendador de citas',
          'Historial completo del cliente',
          'Módulo de servicios',
          'Control de clientes',
          'Cálculo de comisiones',
        ],
        note: null,
        noDiscount: true,
      },
      {
        name: 'Pro',
        price: 150000,
        wompiLink: 'https://checkout.wompi.co/l/Rdf4wT',
        users: '5 usuarios + Admin',
        highlight: true,
        badge: '⚡ LANZAMIENTO 40% OFF',
        features: [
          'Todo lo del Plan Básico',
          'Cuentas de Cobro y Facturación',
          'Cotizador y Facturación Rápida',
          'Chat IA: soporte en inventario y servicios',
          'Gestión de rendimiento e informes',
          'Usuarios adicionales $15.000 c/u',
        ],
        note: 'Usuarios adicionales $15.000/mes c/u',
      },
    ],
  },
];

/* ─── Tarjeta plan normal ─── */
const PlanCard = ({ plan, nicheId, onSelectPlan }) => {
  const [withAI, setWithAI] = useState(false);

  const price = plan.dualPrice && withAI ? plan.priceAlt : plan.price;
  const origPrice = plan.noDiscount ? null : real(price);
  const wompiLink = plan.dualPrice && withAI && plan.wompiLinkAlt ? plan.wompiLinkAlt : plan.wompiLink;

  const handleSelect = () => {
    onSelectPlan && onSelectPlan(nicheId, plan.name, price, wompiLink);
    document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="glass-card rounded-2xl p-6 flex flex-col h-full relative">
      {plan.badge && (
        <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap text-xs font-black px-3 py-1 rounded-full shadow"
          style={{ background: plan.highlight ? 'linear-gradient(90deg,#7c3aed,#8b5cf6)' : 'rgba(255,255,255,0.12)', color: '#fff', border: '1px solid rgba(255,255,255,0.2)' }}>
          {plan.badge}
        </span>
      )}

      <div className="mb-4 mt-2">
        <h3 className="text-white font-black text-xl">Plan {plan.name}</h3>
        <p className="text-white/40 text-xs mt-0.5">{plan.users}</p>
      </div>

      {/* Precio */}
      <div className="mb-5">
        {origPrice && (
          <p className="text-white/35 text-sm line-through mb-0.5">
            Precio real: {fmt(origPrice)}/mes
          </p>
        )}
        <div className="flex items-end gap-1">
          <span className="text-brand-400 font-black text-4xl">{fmt(price)}</span>
          <span className="text-white/50 text-sm mb-1">/mes</span>
        </div>
        {!plan.noDiscount && (
          <span className="inline-block mt-1 text-xs bg-brand-500/15 text-brand-300 px-2 py-0.5 rounded-full border border-brand-500/20">
            40% descuento de lanzamiento
          </span>
        )}

        {/* Toggle IA */}
        {plan.dualPrice && (
          <div className="mt-3 flex items-center gap-3">
            <button
              onClick={() => setWithAI(false)}
              className={`text-xs px-3 py-1 rounded-full border transition-all ${!withAI ? 'bg-brand-500 text-white border-brand-500' : 'text-white/40 border-white/15 hover:border-white/30'}`}>
              Sin Chat IA
            </button>
            <button
              onClick={() => setWithAI(true)}
              className={`text-xs px-3 py-1 rounded-full border transition-all ${withAI ? 'bg-brand-500 text-white border-brand-500' : 'text-white/40 border-white/15 hover:border-white/30'}`}>
              Con Chat IA
            </button>
          </div>
        )}
      </div>

      {/* Features */}
      <ul className="space-y-2 flex-1 mb-5">
        {plan.features.map((f) => (
          <li key={f} className="flex items-start gap-2">
            <CheckIcon />
            <span className="text-white/70 text-sm">{f}</span>
          </li>
        ))}
      </ul>

      {plan.note && (
        <p className="text-white/35 text-xs border-t border-white/8 pt-3 mb-4">{plan.note}</p>
      )}

      <button
        onClick={handleSelect}
        className="block w-full text-center text-white/90 font-bold text-sm px-4 py-3 rounded-xl transition-all hover:opacity-80 mt-auto"
        style={{ background: 'rgba(124,58,237,0.25)', border: '1px solid rgba(124,58,237,0.4)' }}>
        Quiero este plan →
      </button>
    </div>
  );
};

/* ─── Tarjeta plan destacado (Pro) ─── */
const ProCard = ({ plan, nicheId, onSelectPlan }) => {
  const [withAI, setWithAI] = useState(false);

  const price = plan.dualPrice && withAI ? plan.priceAlt : plan.price;
  const origPrice = plan.noDiscount ? null : real(price);
  const wompiLink = plan.dualPrice && withAI && plan.wompiLinkAlt ? plan.wompiLinkAlt : plan.wompiLink;

  const handleSelect = () => {
    onSelectPlan && onSelectPlan(nicheId, plan.name, price, wompiLink);
    document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="rounded-2xl p-6 flex flex-col h-full relative shadow-2xl"
      style={{ background: 'linear-gradient(135deg, #5b21b6 0%, #7c3aed 55%, #8b5cf6 100%)' }}>

      {plan.badge && (
        <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap text-xs font-black px-3 py-1 rounded-full shadow"
          style={{ background: '#fff', color: '#6d28d9' }}>
          {plan.badge}
        </span>
      )}

      <div className="mb-4 mt-2">
        <h3 className="text-white font-black text-xl">Plan {plan.name}</h3>
        <p className="text-white/60 text-xs mt-0.5">{plan.users}</p>
      </div>

      {/* Precio */}
      <div className="mb-5">
        {origPrice && (
          <p className="text-white/50 text-sm line-through mb-0.5">
            Precio real: {fmt(origPrice)}/mes
          </p>
        )}
        <div className="flex items-end gap-1">
          <span className="text-white font-black text-4xl">{fmt(price)}</span>
          <span className="text-white/60 text-sm mb-1">/mes</span>
        </div>
        <span className="inline-block mt-1 text-xs bg-white/20 text-white px-2 py-0.5 rounded-full">
          Ahorras {fmt(origPrice - price)}/mes · 40% OFF
        </span>

        {/* Toggle IA */}
        {plan.dualPrice && (
          <div className="mt-3 flex items-center gap-3">
            <button
              onClick={() => setWithAI(false)}
              className={`text-xs px-3 py-1 rounded-full border transition-all ${!withAI ? 'bg-white text-brand-700 border-white font-bold' : 'text-white/60 border-white/30 hover:border-white/60'}`}>
              Sin Chat IA
            </button>
            <button
              onClick={() => setWithAI(true)}
              className={`text-xs px-3 py-1 rounded-full border transition-all ${withAI ? 'bg-white text-brand-700 border-white font-bold' : 'text-white/60 border-white/30 hover:border-white/60'}`}>
              Con Chat IA
            </button>
          </div>
        )}
      </div>

      {/* Features */}
      <ul className="space-y-2 flex-1 mb-5">
        {plan.features.map((f) => (
          <li key={f} className="flex items-start gap-2">
            <CheckIconWhite />
            <span className="text-white/90 text-sm">{f}</span>
          </li>
        ))}
      </ul>

      {plan.note && (
        <p className="text-white/60 text-xs border-t border-white/20 pt-3 mb-4">{plan.note}</p>
      )}

      <button
        onClick={handleSelect}
        className="block w-full text-center text-brand-700 font-black text-sm px-4 py-3 rounded-xl transition-all hover:opacity-90 hover:scale-105 shadow-lg mt-auto"
        style={{ background: '#fff' }}>
        Quiero este plan →
      </button>
    </div>
  );
};

/* ─── Componente principal ─── */
const Pricing = ({ onSelectPlan }) => {
  const [activeNiche, setActiveNiche] = useState(NICHES[0].id);
  const niche = NICHES.find((n) => n.id === activeNiche);

  return (
    <section id="precios" className="py-24 bg-dark relative overflow-hidden">

      {/* Fondo */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[700px] h-[400px] rounded-full"
          style={{ background: 'radial-gradient(circle, rgba(124,58,237,0.12) 0%, transparent 70%)', filter: 'blur(80px)' }} />
      </div>

      <div className="max-w-6xl mx-auto px-5 relative">

        {/* Encabezado */}
        <div className="text-center mb-10">
          <span className="inline-block bg-brand-500/15 text-brand-400 text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4 border border-brand-500/20">
            Planes y Precios por Negocio
          </span>
          <h2 className="text-4xl md:text-5xl font-black text-white leading-tight">
            Precios adaptados a tu sector.<br />
            <span className="text-brand-400">Sin pagar de más.</span>
          </h2>
          <p className="text-white/40 mt-4 text-lg max-w-2xl mx-auto">
            Este software integrado cuesta con otros proveedores{' '}
            <span className="text-white font-bold line-through">${fmt(COMPETITORS_TOTAL).slice(1)}/mes</span>.
            Con nosotros pagas una fracción. Nuestro plan Pro tiene{' '}
            <span className="text-brand-400 font-bold">40% de descuento de lanzamiento.</span>
          </p>
        </div>

        {/* Banner comparativo */}
        <div className="flex items-center justify-center gap-3 mb-10 flex-wrap">
          <div className="glass-card rounded-xl px-4 py-3 flex items-center gap-2">
            <span className="text-red-400 text-lg">❌</span>
            <span className="text-white/50 text-sm">Competencia: <strong className="text-red-400">${fmt(COMPETITORS_TOTAL).slice(1)}+/mes</strong> · 3 apps distintas</span>
          </div>
          <span className="text-white/30 text-xl font-thin hidden sm:block">→</span>
          <div className="glass-card rounded-xl px-4 py-3 flex items-center gap-2"
            style={{ border: '1px solid rgba(124,58,237,0.4)' }}>
            <span className="text-brand-400 text-lg">✅</span>
            <span className="text-white/80 text-sm">Tu negocio: <strong className="text-brand-400">todo en uno</strong>, desde <strong className="text-white">$90.000/mes</strong></span>
          </div>
        </div>

        {/* Selector de nicho */}
        <div className="flex justify-center mb-10">
          <div className="glass-card rounded-2xl p-1.5 flex gap-2 flex-wrap justify-center"
            style={{ border: '1px solid rgba(255,255,255,0.08)' }}>
            {NICHES.map((n) => (
              <button
                key={n.id}
                onClick={() => setActiveNiche(n.id)}
                className={`flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-bold transition-all ${
                  activeNiche === n.id
                    ? 'text-white shadow-lg'
                    : 'text-white/45 hover:text-white/70'
                }`}
                style={activeNiche === n.id
                  ? { background: 'linear-gradient(135deg,#6d28d9,#8b5cf6)' }
                  : {}}>
                <span>{n.icon}</span>
                <span>{n.label}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Planes del nicho seleccionado */}
        <div className={`grid gap-6 mb-10 ${niche.plans.length === 3 ? 'md:grid-cols-3' : 'md:grid-cols-2 max-w-3xl mx-auto'}`}>
          {niche.plans.map((plan) =>
            plan.highlight
              ? <ProCard key={plan.name} plan={plan} nicheId={activeNiche} onSelectPlan={onSelectPlan} />
              : <PlanCard key={plan.name} plan={plan} nicheId={activeNiche} onSelectPlan={onSelectPlan} />
          )}
        </div>

        {/* Banner Facturación Electrónica */}
        <div className="glass-card rounded-2xl p-6 md:flex items-center justify-between gap-6 mb-6 border border-brand-500/30" style={{ background: 'rgba(124, 58, 237, 0.05)' }}>
          <div className="flex items-start gap-4 mb-4 md:mb-0">
            <div className="text-3xl flex-shrink-0">🧾</div>
            <div>
              <p className="text-white font-black text-lg">Facturación Electrónica (DIAN)</p>
              <p className="text-white/70 text-sm mt-1">
                Adiciona facturación electrónica a cualquier plan por <span className="text-brand-400 font-bold">$60.000/mes adicionales</span>. Lo activas directamente desde la plataforma.
              </p>
              <p className="text-white/40 text-xs mt-1">
                Precio promocional para los primeros 10 clientes (Precio normal: <span className="line-through">$90.000</span>).
              </p>
            </div>
          </div>
        </div>

        {/* Banner urgencia */}
        <div className="glass-card rounded-2xl p-6 md:flex items-center justify-between gap-6 mb-6">
          <div className="flex items-start gap-4 mb-5 md:mb-0">
            <div className="text-3xl flex-shrink-0">🚀</div>
            <div>
              <p className="text-white font-black text-lg">Oferta de lanzamiento · Solo los primeros 20 negocios</p>
              <p className="text-white/40 text-sm mt-1">
                El plan Pro tiene <span className="text-brand-400 font-bold">40% de descuento</span> calculado sobre el costo real del servicio.
                Regístrate ahora y <span className="text-white font-bold">bloquea tu precio</span> mientras seas cliente activo.
              </p>
            </div>
          </div>
          <button
            onClick={() => document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' })}
            className="flex-shrink-0 inline-block text-white font-black text-sm px-8 py-4 rounded-xl transition-all shadow-lg hover:opacity-90 hover:scale-105 whitespace-nowrap"
            style={{ background: 'linear-gradient(135deg, #6d28d9, #8b5cf6)', boxShadow: '0 8px 24px rgba(124,58,237,0.4)' }}>
            Registrar mi Negocio →
          </button>
        </div>

        <p className="text-center text-white/25 text-sm">
          Sin contratos de permanencia · Cancela cuando quieras · Soporte incluido en todos los planes
        </p>

      </div>
    </section>
  );
};

export default Pricing;
